import React, { useState } from "react";
import { Route, Redirect } from "react-router-dom";
//Helpers
import { getRedirectPath } from "Helpers/History";
import { useEffect } from "react";
import { propertiesMenuItems } from "Constants/propertiesMenuItems";
import { read } from "Helpers/LocalStorage";
import { SettingsMenuItems } from "Constants/SettingsMenuItems";
import { useDispatch, useSelector } from "react-redux";
import {
  changeContract,
  changeTableData,
  editDataSelected,
} from "../../../Stores/actions/ContractActions";

const PrivateRoute = ({
  component: Component,
  restricted,
  props,
  isLoggedIn,
  ...res
}) => {
  const { contractData, tableDataContract, isLocked } = useSelector(
    (state) => ({
      contractData: state.contract.contractData,
      tableDataContract: state.contract.tableDataContract,
      isLocked: state.auth.isLocked,
    })
  );

  const [propertiesMenu, setPropertiesMenu] = useState([]);
  const [settingMenu, setSettingMenu] = useState([]);
  const dispatch = useDispatch();

  const renderComponent = (props) => {
    const pathSplit = res.location.pathname.split("/");
    if (pathSplit[2] === "properties" && pathSplit[3]) {
      const menu = propertiesMenu.find((item) => {
        return item.path === res.location.pathname;
      });
      if (menu?.active) {
        return <Component {...props} />;
      } else if (menu && !menu.active) {
        return <Redirect to={`/dashboard/properties`} />;
      }
    } else if (pathSplit[2] === "settings" && pathSplit[3]) {
      const menu = settingMenu.find((item) => {
        return item.path === res.location.pathname;
      });
      if (menu?.active) {
        return <Component {...props} />;
      } else if (menu && !menu.active) {
        return <Redirect to={`/dashboard/settings`} />;
      }
    } else {
      return <Component {...props} />;
    }
  };

  useEffect(() => {
    let updatePropertiesMenuItems = [...propertiesMenuItems];
    updatePropertiesMenuItems.map((item) => {
      if (item.menu_title === "services") {
        item.active = read("khadamatRules");
        return null;
      }
      if (item.menu_title === "FoamMastic") {
        item.active = read("fomMasticRules");
        return null;
      }
      if (item.menu_title === "rokob") {
        item.active = read("rokubRules");
        return null;
      }
      if (item.menu_title === "shishe") {
        item.active = read("mahsoleShisheRules");
        return null;
      }
      if (item.menu_title === "tori") {
        item.active = read("toriRules");
        return null;
      }
      if (item.menu_title === "yaragh") {
        item.active = read("yaraghRules");
        return null;
      }
      if (item.menu_title === "profile") {
        item.active = read("addSeriProfileRules");
        return null;
      }
    });
    setPropertiesMenu(updatePropertiesMenuItems);

    let updateSettingsMenuItems = [...SettingsMenuItems];
    updateSettingsMenuItems.map((item) => {
      if (item.menu_title === "tanzimatTarahi") {
        item.active = read("settingDesignerRules");
        return null;
      }
      if (item.menu_title === "tanzimatGozareshatTolide") {
        item.active = read("settingConstructRules");
        return null;
      }
      if (item.menu_title === "tanzimatGozareshatMali") {
        item.active = read("settingFactorRules");
        return null;
      }
      if (item.menu_title === "tanzimatShop") {
        item.active = true; //! set access
        return null;
      }
    });
    setSettingMenu(updateSettingsMenuItems);
  }, []);

  const resetRedux_Contract = () => {
    if (tableDataContract.length > 0 || contractData.length > 0) {
      dispatch(changeContract([]));
      dispatch(changeTableData([]));
      dispatch(editDataSelected(null));
    }
  };

  useEffect(() => {
    if (res.path !== "/dashboard/projects/contract") {
      resetRedux_Contract();
    }
  }, [res.path]);

  return (
    <>
      {res.path === "/maintenance" ? (
        isLoggedIn && isLocked ? (
          <Route
            {...res}
            render={(props) => {
              return <Component {...props} />;
            }}
          />
        ) : (
          <Redirect to={`/dashboard`} />
        )
      ) : (
        <Route
          {...res}
          render={(props) => {
            const redirect = getRedirectPath(props);
            return isLoggedIn ? (
              <>{renderComponent(props)}</>
            ) : (
              <Redirect to={`/auth/sign_in`} />
            );
          }}
        />
      )}
    </>
  );
};

export default PrivateRoute;
